import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core'
import { Badge, Icon, Typography } from 'foundations-library/components'
import { ScreenSizeContext } from 'providers'
import Button from './../Button'
import { useAppContext } from '../../contexts/AppContext'
import { processLink } from '../../utils/utils'
import { useHistory } from 'react-router-dom'

const isSmallScreen = (screenSize) => screenSize.mobile || screenSize.tablet

const jss = (theme) => {
    const { typography, colors } = theme['foundations-library']
    const logoSize = '160px'
    const column = {
        flex: ({ screenSize }) => isSmallScreen(screenSize) ? '100%' : '50%',
        maxWidth: ({ screenSize }) => isSmallScreen(screenSize) ? '100%' : '50%'
    }
    return {
        content: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            flexDirection: ({ screenSize }) => isSmallScreen(screenSize) && 'column',
            background: 'linear-gradient(100.59deg, #F2F1F1 13.72%, #FD9A27 106.72%)'
        },
        leftImgParent: {
            ...column,
            position: 'relative'
        },
        leftImg: {
            display: 'block',
            width: '100%',
            height: 'auto',
            position: ({ screenSize }) => !isSmallScreen(screenSize) && 'absolute',
            bottom: ({ screenSize }) => !isSmallScreen(screenSize) && '0',
            right: ({ screenSize }) => !isSmallScreen(screenSize) && '0',
            maxHeight: '594px',
            maxWidth: '780px'
        },
        textContainer: {
            ...column,
            padding: ({ screenSize }) => isSmallScreen(screenSize) ? '20px' : '40px 0 145px 70px',
            display: 'flex',
            flexDirection: ({ screenSize }) => isSmallScreen(screenSize) && 'column',
            gap: '30px',
            textAlign: ({ screenSize }) => isSmallScreen(screenSize) && 'center'
        },
        title: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: ({ screenSize }) => isSmallScreen(screenSize) && 'center',
            whiteSpace: ({ screenSize }) => !screenSize.mobile && 'nowrap'
        },
        text: {
            paddingTop: '18px'
        },
        logo: {
            height: logoSize,
            width: logoSize,
            margin: ({ screenSize }) => isSmallScreen(screenSize) && 'auto'
        },
        buttonsContainer: {
            marginBottom: '94px'
        },
        features: {
            display: 'flex',
            flexDirection: ({ screenSize }) => isSmallScreen(screenSize) && 'column',
            gap: ({ screenSize }) => !isSmallScreen(screenSize) && '20px',
            marginTop: ({ screenSize }) => !isSmallScreen(screenSize) && '50px',
            ...typography.h6
        },
        featuresColumn: {
            '& div': {
                marginBottom: '15px',
                textAlign: ({ screenSize }) => screenSize.mobile && 'left',
                '& span': {
                    whiteSpace: 'nowrap',
                    borderLeft: `2px solid ${colors.primary[400]}`,
                    paddingLeft: '8px'
                }
            }
        },
        badge: {
            color: `${colors.neutral[900]} !important`
        },
        company: {
            marginTop: '6px'
        },
        phrase: {
            whiteSpace: ({ screenSize }) => !isSmallScreen(screenSize) && 'nowrap',
            marginTop: '6px',
            marginBottom: '15px'
        }
    }
}

const useStyles = makeStyles(jss)

/**
 *
 */
const EsimHeader = (): JSX.Element => {
    const { app } = useAppContext()
    const screenSize = useContext(ScreenSizeContext)
    const styles = useStyles({ screenSize })
    const history = useHistory()

    const handleClick = () => {
        processLink('/stepper', history, true)
    }

    return (
        app.identifier === 'ESIM' && !window.location.href.includes('stepper')
            ? <div className={styles.content}>
                <div className={styles.textContainer}>
                    <img
                        className={styles.logo}
                        src="https://s3.us-west-2.amazonaws.com/assets.phone.com/esim-store/app-icon-light-green.png"
                        alt="bg.png"
                        data-testid='esim-logo'
                    />
                    <div className={styles.text}>
                        <Typography variant='h3' data-testid='esim-title' className={styles.title}>
                            {app.title}&nbsp;
                            <Badge size='small' color='primary' className={styles.badge}>
                                <Icon name='tag' color='neutral-900' size={16} /> 1 month free
                            </Badge>
                        </Typography>
                        <Typography className={styles.company} variant='body1' color='neutral-500' data-testid='esim-company'>{app.company}</Typography>
                        <Typography variant='h8' className={styles.phrase} data-testid='esim-phrase'>
                            Enjoy all your Phone.com enterprise features with ProSIM
                            <br />
                            over a cellular network.
                        </Typography>
                        <div className={styles.buttonsContainer} data-testid='esim-buttons'>
                            {
                                app.buttons &&
                                app.buttons.map(
                                    (button, index) => (
                                        <Button
                                            key={index}
                                            handleClick={handleClick.bind(this)}
                                            {...button}
                                        />
                                    )
                                )
                            }
                        </div>

                        <div className={styles.features} data-testid='esim-features'>
                            <div className={styles.featuresColumn}>
                                <div><span>ProSIM</span></div>
                                <div><span>Native Dialer</span></div>
                                <div><span>Secure & Easy</span></div>
                            </div>
                            <div className={styles.featuresColumn}>
                                <div>
                                    <span>Duality</span>
                                </div>
                                <div>
                                    <span>Connected Devices</span>
                                </div>
                                <div>
                                    <span>Smart Features</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.leftImgParent}>
                    <img
                        className={styles.leftImg}
                        src="https://s3.us-west-2.amazonaws.com/assets.phone.com/esim-store/esim-header.png"
                        data-testid='esim-img'
                    />
                </div>
            </div>
            : <></>)
}

export default EsimHeader
